import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../core/auth.service';
import { take, map, tap } from 'rxjs/operators';

@Component({
  selector: 'app-top-nav',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.scss']
})
export class TopNavComponent {
  userLogined = false;
  displayName = '';
  constructor(public authService: AuthService) {
    this.authService.user.subscribe(u => {
      if (u && u.displayName) {
        this.displayName = u.displayName;
      }
    });
  }
  logout() {
    this.authService.signOut();
  }
}
